<template>
  <div class="calico-file-card">
    <i :class="`bi bi-filetype-${type} type-${type}`" />
    <label
      class="name label--medium"
      :title="name"
    >
      {{ name }}
    </label>
    <label class="size label--small">
      {{ size }}
    </label>
  </div>
</template>

<script>
export default {
  name: "CalicoFileCard",
  props: {
    name: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "",
    },
    size: {
      type: String,
      default: "",
    }
  },
};
</script>

<style lang="scss">
.calico-file-card {
  @include inset-space($space-small);
  @include inline-space($space-medium);
  align-items: center;
  border: 1px solid $color-neutral-light;
  border-radius: $radius-medium;
  max-width: 351px;
  width: 100%;
  .name {
    flex: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.2;
  }
  .size {
    color: $color-text-secondary;
  }
  .type-pdf {
    color: $color-red;
  }
  .type-png {
    color: $color-lapis;
  }
  .type-jpg {
    color: $color-pink;
  }
  .type-doc {
    color: $color-cyan-dark;
  }
  .type-docx {
    color: $color-cyan-dark;
  }
}
</style>